module.exports = __webpack_public_path__ + "static/media/bathroom.ff3385c2.svg";